<template>
    <kgr-profile-part v-if="!isEmpty">
        <template #heading>
            <div class="kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-row">
                <div class="kgr-postfix__fixed">
                    <h2 class="kgr-headline kgr-headline--h3">
                        {{ $t('Bevorstehende Angebote (max. 3 Termine)') }}
                    </h2>
                </div>
            </div>
        </template>

        <template #content>
            <table class="kgr-table">
                <tr
                    v-for="offeringBooking in memberShortProfile.offeringBookings"
                    class="kgr-table__row kgr-table__row--top"
                >
                    <td class="kgr-table__cell">
                        {{ offeringBooking.offering.title }} ({{ getCategoryName(offeringBooking.offering) }})
                    </td>
                    <td class="kgr-table__cell">
                        {{ offeringBooking.start }} {{ $t('Uhr') }}
                    </td>
                </tr>
            </table>
        </template>
    </kgr-profile-part>
</template>

<script>
import MemberShortProfile from '../../../js/dto/MemberShortProfile';
import ProfilePart from '../../short-profile/ProfilePart';

export default {
    name: 'kgr-member-offering-bookings',
    components: {
        'kgr-profile-part': ProfilePart,
    },
    props: {
        memberShortProfile: {
            type: MemberShortProfile,
            required: true,
        },
    },
    computed: {
        isEmpty() {
            return this.memberShortProfile.offeringBookings.length === 0;
        }
    },
    methods: {
        getCategoryName(offering) {
            return offering.offeringCategory.name === 'training' || offering.offeringCategory.name === 'course' ?
                this.$t(offering.offeringCategory.name) :
                offering.offeringCategory.name
        }
    }
}
</script>
